import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IDistrict } from '../../types/district';

export const Selector = (state: StoreState) => state.districts.data.list;

export const selectNameDistricts = createSelector(Selector, (items): { label: string; value: number | string }[] => {
    const arrSel: { label: string; value: number | string }[] = [];

    items.forEach((item: IDistrict) => {
        arrSel.push({ label: item?.name, value: item.id });
    });
    arrSel.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return arrSel;
});
export const miniLoaderForSelector = (state: StoreState) => state.students.miniLoaderFor;
export const loaderSelector = (state: StoreState) => state.students.inProgress;
